module.exports = __webpack_public_path__ + "img/430.894af9ff.jpg";